// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lite-sidebar-main-label[data-v-659b6264] {\n    margin: 20px 0;\n    font-weight: bold;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    display: block;\n    overflow: hidden;\n    font-size: 18px;\n    font-family: 'Red Ring', sans-serif;\n    color: #292929;\n}\n\n", ""]);
// Exports
module.exports = exports;
